import { ThemeUICSSObject } from 'theme-ui';

export enum ALERT_VARIANTS {
  info = 'info',
  success = 'success',
  warning = 'warning',
  error = 'error',
  inputError = 'inputError',
}

const defaultAlertStyles: ThemeUICSSObject = {
  display: 'flex',
  alignItems: 'center',
  gap: 2,
  variant: 'text.sm',
  border: `1px solid`,
  borderColor: 'transparent',
  paddingX: 5,
  paddingY: 3,
  boxShadow: 'xs',
  borderRadius: 'md',
  textDecoration: 'none',
};

export const alerts: Record<ALERT_VARIANTS, ThemeUICSSObject> = {
  info: {
    ...defaultAlertStyles,
    backgroundColor: 'blueScale.1',
    borderColor: 'blueScale.2',
    color: 'blueScale.4',
  },
  success: {
    ...defaultAlertStyles,
    backgroundColor: 'successScale.1',
    borderColor: 'successScale.2',
    color: 'successScale.4',
  },
  warning: {
    ...defaultAlertStyles,
    backgroundColor: 'warningScale.1',
    borderColor: 'warningScale.2',
    color: 'warningScale.4',
  },
  error: {
    ...defaultAlertStyles,
    backgroundColor: 'errorScale.1',
    borderColor: 'errorScale.2',
    color: 'errorScale.4',
  },
  inputError: {
    ...defaultAlertStyles,
    boxShadow: 'none',
    backgroundColor: 'transparent',
    color: 'redScale.4',
    padding: 0,
  },
};
